@if (baseSite!=='EMEA') {
  @for (item of productCategoriesDetails; track item) {
    <ng-container class="container">
      @if (item) {
        <div class="categories-section">
          <a [href]="item.url" class="d-flex justify-content-center">
            @if (item.categoryImage?.url) {
              <img src="{{baseUrl}}{{item.categoryImage?.url}}" alt="{{item.uid}}" />
            }
          </a>
          <div class="d-flex justify-content-center category-name">
            <span class="categoryName">
              {{item.linkName}}
            </span>
          </div>
        </div>
      }
    </ng-container>
  }
}
@if (baseSite==='EMEA') {
  @for (item of productCategoriesDetails; track item) {
    <ng-container class="container">
      @if (item) {
        <div class="categories-section">
          <a [href]="item.urlLink" target="_blank" class="d-flex justify-content-center">
            @if (item.media?.url) {
              <img src="{{baseUrl}}{{item.media?.url}}" />
            }
          </a>
          <div class="d-flex justify-content-center category-name">
            <span class="categoryName">
              {{item.name}}
            </span>
          </div>
        </div>
      }
    </ng-container>
  }
}